module.exports = __webpack_public_path__ + "static/7a098b1b-ff3e-40f4-b611-c1cb1f89d2fc-16782c9314c78c6572ebb2e5b236e173.webp";